/* eGURU — hiệu ứng "sóng sáng" cho khối logo đối tác (Veena logo_bar / .wblogos).
   Giữ nguyên lưới logo gốc, chỉ gán biến CSS: --wave-count cho cả khối và --i
   (thứ tự) cho từng logo → CSS chạy sóng bừng-màu tuần tự. Bỏ qua nếu không có. */
(function () {
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.wblogos'), function (sec) {
      var imgs = sec.querySelectorAll('.logo-bar__image');
      if (imgs.length < 3) return;
      sec.style.setProperty('--wave-count', imgs.length);
      Array.prototype.forEach.call(imgs, function (img, i) {
        img.style.setProperty('--i', i);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
